<template>
  <v-card>
    <v-form id="announcement_form" ref="form" v-model="valid" lazy-validation>
      <v-card-title class="headline">
        {{title}}
      </v-card-title>
      <v-divider/>
      <v-list>
        <v-layout row wrap px-3 py-2>
          <v-text-field name="message" required multi-line :rules="requiredRule" :label="$t('announcements.message')" :placeholder="$t('announcements.edit.dialog_message_placeholder')" v-model="message"/>
          <v-flex xs12>
            <date-range-picker update-start="SET_EDIT_ANNOUNCEMENT_START_DATE" update-end="SET_EDIT_ANNOUNCEMENT_END_DATE"
                              :date-range="{startDate: startDate, endDate: endDate}" indefinite="true" end-unlimited/>
          </v-flex>
          <v-flex xs6 pr-1>
            <v-select :label="$t('announcements.visibility')" required multiple :rules="roleSelectRule" :items="roleFields" v-model="rolesSelected"/>
          </v-flex>
          <v-flex xs6 pl-1>
            <v-select :label="$t('announcements.severity')" required :rules="requiredRule" :items="severitiesFields" v-model="severitySelected"/>
          </v-flex>
        </v-layout>
      </v-list>
      <v-card-actions>
        <v-spacer/>
        <v-btn flat color="primary" @click="cancel">
          {{$t("cancel")}}
        </v-btn>
        <v-btn flat color="primary" @click="save">
          {{$t("save")}}
        </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>
<script>
  import {
    SET_EDIT_ANNOUNCEMENT_MESSAGE,
    SET_ANNOUNCEMENT_DIALOG_STATE,
    SET_EDIT_ANNOUNCEMENT_END_DATE,
    SET_EDIT_ANNOUNCEMENT_ROLES,
    SET_EDIT_ANNOUNCEMENT_SEVERITY,
    SET_EDIT_ANNOUNCEMENT_START_DATE,
    SET_ANNOUNCEMENT_FORM_VALID,
    EDIT_ANNOUNCEMENT
  } from '../../../store/mutation-types'
  import { GET_ANNOUNCEMENT_DIALOG_STATE } from '../../../store/getter-types'
  import DateRangePicker from '../../date/DateRangePicker'
  import Helpers from '../../../mixins/Helpers'
  import { mapActions, mapMutations, mapGetters } from 'vuex'
  import { SAVE_NEW_ANNOUNCEMENT, SAVE_EDIT_ANNOUNCEMENT } from '../../../store/action-types'

  export default {
    name: 'announcement-edit-dialog',
    components: {DateRangePicker},
    props: {},
    mixins: [Helpers],
    data () {
      return {
        requiredRule: [v => !!v || this.$t('field_required')],
        roleSelectRule: [v => (!!v && v.length > 0) || this.$t('field_required')],

        severities: [
          {
            text: 'announcements.severities.INFO',
            value: 'INFO'
          },
          {
            text: 'announcements.severities.WARNING',
            value: 'WARNING'
          },
          {
            text: 'announcements.severities.ERROR',
            value: 'ERROR'
          },
          {
            text: 'announcements.severities.CRITICAL',
            value: 'CRITICAL'
          }
        ],
        roles: [
          {
            text: 'announcements.roles.ROLE_STUDENT',
            value: 'ROLE_STUDENT'
          },
          {
            text: 'announcements.roles.ROLE_STAFF',
            value: 'ROLE_STAFF'
          },
          {
            text: 'announcements.roles.ROLE_ADMIN',
            value: 'ROLE_ADMIN'
          }
        ]
      }
    },
    methods: {
      ...mapGetters({
        getDialogState: GET_ANNOUNCEMENT_DIALOG_STATE
      }),
      ...mapActions({
        saveAnnouncement: SAVE_NEW_ANNOUNCEMENT,
        editAnnouncement: SAVE_EDIT_ANNOUNCEMENT
      }),
      ...mapMutations({
        setDefaultState: EDIT_ANNOUNCEMENT,
        setDialogState: SET_ANNOUNCEMENT_DIALOG_STATE
      }),
      save () {
        if (this.$refs.form.validate()) {
          if (this.isEditMode) {
            this.editAnnouncement()
          } else {
            this.saveAnnouncement()
          }
        }
      },
      cancel () {
        this.setDialogState({visible: false})
      }
    },
    computed: {
      isEditMode () {
        return this.getDialogState().edit
      },
      title () {
        return this.isEditMode
          ? this.$t('announcements.dialog.edit.title')
          : this.$t('announcements.dialog.create.title')
      },
      severitiesFields () {
        return this.translateFields(this.severities)
      },
      roleFields () {
        return this.translateFields(this.roles)
      },
      message: {
        get () {
          return this.$store.state.announcement.editAnnouncement.message
        },
        set (value) {
          this.$store.commit(SET_EDIT_ANNOUNCEMENT_MESSAGE, value)
        }
      },
      startDate: {
        get () {
          return this.$store.state.announcement.editAnnouncement.fromDate
        },
        set (startDate) {
          console.log(startDate)
          this.$store.commit(SET_EDIT_ANNOUNCEMENT_START_DATE, startDate)
        }
      },
      endDate: {
        get () {
          return this.$store.state.announcement.editAnnouncement.toDate
        },
        set (endDate) {
          this.$store.commit(SET_EDIT_ANNOUNCEMENT_END_DATE, endDate)
        }
      },
      rolesSelected: {
        get () {
          return this.$store.getters.GET_EDIT_ANNOUNCEMENT_ROLE_ARRAY
        },
        set (values) {
          this.$store.commit(SET_EDIT_ANNOUNCEMENT_ROLES, values)
        }
      },
      severitySelected: {
        get () {
          return this.$store.state.announcement.editAnnouncement.severity
        },
        set (value) {
          this.$store.commit(SET_EDIT_ANNOUNCEMENT_SEVERITY, value)
        }
      },
      valid: {
        get () {
          return this.$store.state.announcement.valid
        },
        set (value) {
          this.$store.commit(SET_ANNOUNCEMENT_FORM_VALID, value)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/announcement/edit/AnnouncementEditDialog.vue